import { Flashbar } from "@amzn/awsui-components-react";
import AppLayout from "@amzn/awsui-components-react/polaris/app-layout";
import SplitPanel from "@amzn/awsui-components-react/polaris/split-panel";
import OrderDetailsSidePanel from "components/ManageOrders/OrderSidePanel";
import { useDetailsSidePanel, useManageOrdersTable } from "components/ManageOrders/useManageOrdersTable";
import { useState } from "react";

import NavigationBreadcrumbs from "../../common/navigation/NavigationBreadcrumbs";
import SideNavigationMenu from "../../common/navigation/SideNavigationMenu";
import Paths from "../../common/paths/paths";
import { getString } from "../../common/ui-string-labels/ui-strings-utils";
import { useFlashBarItems } from "../../common/UseFlashBarItems/useFlashBarItems";
import { NavigationChangeEvent,SplitPanelPreferencesChangeEvent, SplitPanelToggleEvent } from "../../components/ChatbotWidget/interfaces";
import useAppDrawers from "../../components/ChatbotWidget/useAppDrawers";
import { ManageOrdersTable } from "../../components/ManageOrders";

const breadcrumbs = {
    items: [
        { text: Paths.Admin.name, href: Paths.uploadLicense.url },
        { text: Paths.manageOrders.name, href: Paths.manageOrders.url },
    ],
};

const ManageOrdersPage = () => {
    const [navigationOpen, setNavigationOpen] = useState(false);
    const [splitPanelPosition, setSplitPanelPosition] = useState<"bottom" | "side">("bottom");
    const flashBarItemsHook = useFlashBarItems();
    const detailsSidePanelHook = useDetailsSidePanel();
    const useManageOrdersTableHook = useManageOrdersTable();
    const drawerProps = useAppDrawers();
    const onSplitPanelClose = () => {
        useManageOrdersTableHook.actions.refreshAttributes();
    };

    return (
        <AppLayout
            headerSelector="#top-nav"
            content={
                <ManageOrdersTable
                    useFlashBarItemsActions={flashBarItemsHook.actions}
                    useDetailsSidePanel={detailsSidePanelHook}
                    useManageOrdersTableHook={useManageOrdersTableHook}
                />
            }
            breadcrumbs={<NavigationBreadcrumbs items={breadcrumbs.items} />}
            navigation={<SideNavigationMenu />}
            navigationOpen={navigationOpen}
            splitPanel={
                detailsSidePanelHook.isOpened ? (
                    <SplitPanel
                        header={detailsSidePanelHook.selectedOrder?.display || getString('manageOrders.splitPanel.title')}
                        i18nStrings={{
                            preferencesTitle: getString('manageOrders.splitPanel.preferencesTitle'),
                            preferencesPositionLabel: getString('manageOrders.splitPanel.positionLabel'),
                            preferencesPositionDescription: getString('manageOrders.splitPanel.positionDescription'),
                            preferencesPositionBottom: getString('manageOrders.splitPanel.positionBottom'),
                            preferencesPositionSide: getString('manageOrders.splitPanel.positionSide'),
                            preferencesCancel: getString('manageOrders.splitPanel.cancel'),
                            preferencesConfirm: getString('manageOrders.splitPanel.confirm'),
                            openButtonAriaLabel: getString('manageOrders.splitPanel.openButtonAriaLabel'),
                            closeButtonAriaLabel: getString('manageOrders.splitPanel.closeButtonAriaLabel'),
                        }}
                    >
                        <OrderDetailsSidePanel selectedOrder={detailsSidePanelHook.selectedOrder} />
                    </SplitPanel>
                ) : undefined
            }
            splitPanelOpen={detailsSidePanelHook.isOpened}
            onSplitPanelToggle={(event: SplitPanelToggleEvent) => {
                if (!event.detail.open) {
                    detailsSidePanelHook.actions.hidePanel();
                    onSplitPanelClose();
                }
            }}
            splitPanelPreferences={{ position: splitPanelPosition }}
            onSplitPanelPreferencesChange={(event: SplitPanelPreferencesChangeEvent) => setSplitPanelPosition(event.detail.position)}
            notifications={<Flashbar items={flashBarItemsHook.flashBarItems} stackItems />}
            onNavigationChange={(event: NavigationChangeEvent) => setNavigationOpen(event.detail.open)}
            {...drawerProps}
        />
    );
};

export default ManageOrdersPage;
